import { useQuery } from '@tanstack/react-query'

import useAuth from 'hooks/useAuth'
import axiosServices from 'utils/axios'

import type { ICustomField } from '../types/query-builder-types'

const fetchCustomField = async (id: number, business_id: number): Promise<ICustomField> => {
  const response = await axiosServices.get(`/businesses/${business_id}/custom_fields/${id}`)
  return response.data
}

export const useFetchCustomField = (id?: number | undefined) => {
  const { user } = useAuth()
  const business_id = user?.business_id!
  return useQuery({
    queryKey: ['fetch-custom-field', business_id, id],
    queryFn: () => fetchCustomField(id!, business_id),
    enabled: !!business_id && !!id
  })
}
